import $ from 'jquery';
import Events from '../events';
import StorelistView from '../views/StorelistView';
import Storelist from '../models/Storelist';
import {getStoreById} from '../data-utils';
import action from '../action';

var doNotScroll = false;

function start(context) {
  var params = Storelist.init(context);
  render(params);
  Storelist.saveState();
}

function refresh(back){
  var params = Storelist.getStorelist();
  if(!back){
    doNotScroll=false;
    Storelist.saveState();
  }else{
    doNotScroll=true;
  }
  render(params);
}

function render(params){
  StorelistView.render(params);
  bindEvents(params);
  setStorlistPosition(params);
}
function setStorlistPosition(params){

  var container = $('.storelist__container');
  container.scrollTop(params.scrollposition);

  if(params.letter!='' && params.sortby == 'name'){

    var scrollTo;

    if(params.view == 'logo'){
      scrollTo = $('.storelist__container .list__item--'+params.letter).first();
    }else{
      scrollTo = $('.storelist__container #'+params.letter);
    }

    if (!scrollTo) return;

    var targetPosition =  scrollTo.offset().top - container.offset().top + container.scrollTop();

    if(params.letter != params.lastletter){
      if(scrollTo.offset().top != params.scrollposition){
        var speed = (doNotScroll === true) ? 0 : 700;

        container.animate({
          scrollTop: targetPosition
        }, {
          duration: speed,
          complete: function() {
            listenSrolling(params.letter, params.view);
          }
        });
      }
    }else{
      container.animate({
        scrollTop: targetPosition
      }, {
        duration: 0,
        complete: function() {
          listenSrolling(params.letter, params.view);
        }
      });
    }
    Storelist.setPosition(targetPosition);
  }
  else if(params.sortby == 'name'){
    //get first visible item on the list
    var first = getFirstElement(params.view);
    $('#alphabets .nav__button--active').removeClass('nav__button--active');
    $('#alphabets #'+first).addClass('nav__button--active');

    listenSrolling(params.letter, params.view);
  }
}
function getFirstElement(view){

  var first;

  var container = $('.storelist__container').first();
  var toplimit = container.offset().top;
  var bottomside = toplimit + container.height();
  var items;

  if(view=='logo'){
    items = $('.storelist__container .list__item');
  }else{
    items = $('.storelist__container h3');
  }

  $.each(items, function(i, item){
    var elementBottom = 0;
    elementBottom = $(item).offset().top + $(item).height();
    if (!first && elementBottom >= toplimit) {
      first = item;
    }
  });
  if(typeof first == 'undefined'){
    first = $('#alphabets .nav__button').first();
  }

  var id = first.id;
  if(view=='logo'){
    id = Storelist.getStoreNameFirstLetter(first.id);
  }

  return id;

}
function listenSrolling(letter, view){

  let [{id: alphabet} = {}] = $('#alphabets .nav__button--active');
  var activeElements;

  if (!alphabet) return;

  if(view == 'logo'){
    activeElements = $('.storelist__container .list__item--'+alphabet);
  }else{
    activeElements = $('.storelist__container #'+alphabet);
  }

  var container = $('.storelist__container').first();
  var containerHeight = container.height();
  var scrollPosition = $( '.storelist__container' ).scrollTop();
  var bottom = 0;
  var top = 0;

  $( '.storelist__container' ).scroll(function() {

    var limitExceeded = false;

    if(view == 'logo'){
      var firstActiveElement = activeElements.first();
      top = firstActiveElement.position().top;
      var lastActiveElement = activeElements.last();
      bottom = lastActiveElement.position().top;
    }else{
      top = activeElements.parent().position().top;
      bottom = activeElements.position().top - activeElements.height();
    }

    var direction = 'next';

    if(scrollPosition > $(this).scrollTop()){
      direction = 'prev';
    }

    var nextLetter = Storelist.getNextLetter(alphabet, direction);

    //if logo group is highlighted, wait until group is scrolled out of view entirely
    if(letter!='' && view=='logo'){
      if(bottom < 0 || top > containerHeight){
        letter = '';
        Storelist.clearLetter();
        if(direction=='prev'){
          nextLetter = getFirstElement(view);
          limitExceeded = true;
        }else{
          limitExceeded = true;
        }
      }
    }
    //in other cases wait until next group has become visible
    else{
      if(view=='logo'){
        top = $('.storelist__container .list__item--'+nextLetter).first().position().top;
      }else{
        top = $('.storelist__container #'+nextLetter).position().top;
      }

      if(direction == 'next' && bottom < 0){
        Storelist.clearLetter();
        limitExceeded = true;
      }
      if(direction =='prev' && top > 0){
        Storelist.clearLetter();
        limitExceeded = true;
      }
    }
    //if limit is exceeded move to the next group
    if(limitExceeded){

      $('.storelist__container .list__item').removeClass('list__item--inactive');
      $('.alphabets .nav__button').removeClass('nav__button--active');

      alphabet=nextLetter;

      if(view=='logo'){
        activeElements = $('.storelist__container .list__item--'+nextLetter);
      }else{
        activeElements = $('.storelist__container #'+nextLetter);
      }

      $('#alphabets #'+nextLetter).addClass('nav__button--active');

    }

    scrollPosition = $(this).scrollTop();
    Storelist.setPosition(scrollPosition);

  });
}

function bindEvents(params){

  $('#backbutton').on('click', async function(e){
    e.stopPropagation();
    if (await Storelist.goBack()){
      refresh('back');
    }
  });
  $('#view-listing .btn--toggle').on('mouseup touchend', function(){
    if(params.scrollposition != params.lastposition && params.letter==''){
      Storelist.updateState();
    }
    Storelist.getStorelist().store = null;
    Storelist.setView(this.id, params.letter);
    refresh();
  });
  $('#sortby .btn--toggle').on('mouseup touchend', function(){
    if(params.scrollposition != params.lastposition && params.letter==''){
      Storelist.updateState();
    }
    Storelist.getStorelist().store = null;
    Storelist.setSortBy(this.id);
    refresh();
  });

  const selectFilter = titleFn => event => {
    event.preventDefault();
    Storelist.setTitle(titleFn(event.currentTarget.id));
    refresh();
  };

  $('#sortby-category .box').on('mouseup touchend', selectFilter(id => {
    Storelist.setCategory(id);
    return Storelist.getCategoryName(id);
  }));

  $('#sortby-floor .floors .box').on('mouseup touchend', selectFilter(id => {
    Storelist.setFloor(id);
    return Storelist.getFloorName(id);
  }));

  $('#sortby-floor .officetowers .box').on('mouseup touchend', selectFilter(id => {
    Storelist.setOfficeTower(id);
    return Storelist.getOfficeTowerName(id);
  }));

  $('#alphabets .nav__button').on('mouseup touchend', function(){
    var currentLetter = params.letter;
    Storelist.getStorelist().store = null;
    Storelist.setAlphabet(this.id, currentLetter);
    refresh();
  });
  $('.change_btn').on('mouseup touchend', function(){
    Storelist.setCategory('');
    refresh();
  });
  $('.store-search-wrapper').on('click', function(){
    Storelist.goTo('#search');
  });
  $('.close,.redirect-popup-overlay').on('click' , function(){
    Storelist.getStorelist().store = null;
    refresh();
  });
  $('.storelist .list__item').on('click', function() {
    const store = getStoreById(this.id);
    Storelist.getStorelist().store = store;
    Storelist.updateLastPosition($('.storelist__container').scrollTop());
    refresh();
    Events.dispatchEvent('poi', { name: store.name, action: 'popup' });
  });
  $('.redirect-store-own').on('click', function() {
    Storelist.getStorelist().store = null;
    refresh();
    action.showStoreInfo(this.id);
  });
  $('.redirect-map').on('click', function () {
    Storelist.getStorelist().store = null;
    refresh();
    action.showStoreOnMap(this.id);
  });

}

export default {
  start,
  refresh,
  render
};
